import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";

const cdnslamService = {
  criar: async (empreendimentoId, arquivoBlob, numeroInformado) => {
    const formData = new FormData();
    formData.append("EmpreendimentoId", empreendimentoId);
    formData.append("Arquivo", arquivoBlob, "CDNSLAM.pdf");
    if (numeroInformado != null && String(numeroInformado).trim() !== "") {
      formData.append("NumeroInformado", String(numeroInformado).trim());
    }

    const response = await axios.post(`${API_URL}CDNSLAM`, formData, {
      headers: {
        ...authService.getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  obterProximoNumero: async () => {
    const response = await axios.get(`${API_URL}CDNSLAM/proximo-numero`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  obterPorId: async (id) => {
    const response = await axios.get(`${API_URL}CDNSLAM/${id}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  obterPorEmpreendimentoId: async (empreendimentoId) => {
    const response = await axios.get(
      `${API_URL}CDNSLAM/empreendimento/${empreendimentoId}`,
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },

  listarMinhas: async (pageNumber = 1, pageSize = 5, nomeEmpreendimento = "", orderBy = "dataSolicitacao", orderDirection = "desc") => {
    const params = new URLSearchParams({
      pageNumber,
      pageSize,
      orderBy,
      orderDirection,
    });
    if (nomeEmpreendimento) params.append("nomeEmpreendimento", nomeEmpreendimento);

    const response = await axios.get(`${API_URL}CDNSLAM/minhas?${params.toString()}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  obterAtividadesElegiveis: async () => {
    const response = await axios.get(`${API_URL}CDNSLAM/atividades-elegiveis`);
    return response.data;
  },

  listarTodasAnalista: async ({
    pageNumber = 1,
    pageSize = 5,
    nomeEmpreendimento = "",
    orderBy = "dataSolicitacao",
    orderDirection = "desc",
  } = {}) => {
    const params = new URLSearchParams({
      pageNumber,
      pageSize,
      orderBy,
      orderDirection,
    });
    if (nomeEmpreendimento) params.append("nomeEmpreendimento", nomeEmpreendimento);

    const response = await axios.get(`${API_URL}CDNSLAM/analista/todas?${params.toString()}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },
};

export default cdnslamService;
